module.exports = __webpack_public_path__ + "static/pulley_spacer-0a8b34711df0de8a8a94dc4516054080.jpg";